#profile-hosting-map {
  width: 100%;
  height: 300px;
}
.btn-offer-hosting-edit {
  float: right;
  margin: 5px 0 0 10px;
}
.btn-offer-hosting-create {
  margin-left: auto;
  margin-right: auto;
}
